
import layout from '@/layout'

// Usually store pages that do not require permission.
const constantRoutes = [
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: () => import('@/views/login')
  },
  {
    path: '/404',
    name: '404',
    hidden: true,
    component: () => import('@/views/error-page/404')
  },
  {
    path: '/',
    name: 'home',
    hidden: true,
    redirect: '/welcome'
  },
  {
    path: '/welcome',
    component: layout,
    children: [
      {
        path: '',
        name: 'welcome',
        component: () => import('@/views/welcome'),
        meta: {
          icon: 's-order',
          title: '欢迎页'
        }
      }
    ]
  }
]

export default constantRoutes
